var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64645 8.64645C5.84171 8.45118 6.15829 8.45118 6.35355 8.64645L10.0908 12.3837C10.4927 12.7856 10.7731 13.0654 11.009 13.2657C11.2404 13.4622 11.3959 13.5525 11.5365 13.5982C11.8377 13.696 12.1623 13.696 12.4635 13.5982C12.6041 13.5525 12.7596 13.4622 12.991 13.2657C13.2269 13.0654 13.5073 12.7856 13.9092 12.3837L17.6464 8.64645C17.8417 8.45118 18.1583 8.45118 18.3536 8.64645C18.5488 8.84171 18.5488 9.15829 18.3536 9.35355L14.6163 13.0908L14.6012 13.1059C14.218 13.4891 13.9089 13.7982 13.6382 14.028C13.3595 14.2646 13.0886 14.4465 12.7725 14.5492C12.2704 14.7124 11.7296 14.7124 11.2275 14.5492C10.9114 14.4465 10.6405 14.2646 10.3618 14.028C10.0911 13.7982 9.78201 13.4891 9.39883 13.1059L9.3837 13.0908L5.64645 9.35355C5.45118 9.15829 5.45118 8.84171 5.64645 8.64645Z",
    fill: "#0A213A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.60b8f5beb1c1705064287c87214dc87c.svg";
export { ForwardRef as ReactComponent };